import { cn } from "../cn.ts";
import { Badge } from "./badge.tsx";
import { PriceBadge } from "./price-badge.tsx";

export interface EpisodeListItemProps {
  href: string;
  episodeNumber: number;
  titleTh: string;
  titleEn: string;
  thumbnailUrl: string;
  runtimeMin: number;
  state: "free" | "unlocked" | "locked";
  priceThb?: number;
  strikePriceThb?: number;
  locale?: "th" | "en";
  className?: string;
}

export function EpisodeListItem({
  href,
  episodeNumber,
  titleTh,
  titleEn,
  thumbnailUrl,
  runtimeMin,
  state,
  priceThb,
  strikePriceThb,
  locale = "en",
  className,
}: EpisodeListItemProps) {
  const title = locale === "th" ? titleTh : titleEn;
  return (
    <a
      href={href}
      className={cn(
        "flex items-center gap-3 rounded-xl bg-[var(--brand-paper)] p-3 transition-colors hover:bg-[var(--brand-pink-soft)]",
        className,
      )}
    >
      <div className="relative aspect-[16/10] w-24 shrink-0 overflow-hidden rounded-lg bg-[var(--brand-pink-soft)] sm:w-32">
        <img
          src={thumbnailUrl}
          alt={title}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-mono text-xs text-[var(--brand-muted)]">EP{episodeNumber}</p>
        <p className="truncate text-sm font-semibold text-[var(--brand-ink)]">{title}</p>
        <p className="text-xs text-[var(--brand-muted)]">
          {locale === "th" ? `${runtimeMin} นาที` : `${runtimeMin} min`}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {state === "free" ? (
          <Badge variant="free">{locale === "th" ? "ฟรี" : "Free"}</Badge>
        ) : state === "unlocked" ? (
          <Badge variant="muted">{locale === "th" ? "ดูได้" : "Watch"}</Badge>
        ) : typeof priceThb === "number" ? (
          <PriceBadge amountThb={priceThb} strikeAmountThb={strikePriceThb} locale={locale} />
        ) : (
          <Badge variant="locked">{locale === "th" ? "ปลดล็อก" : "Unlock"}</Badge>
        )}
      </div>
    </a>
  );
}
